import { ConfigParams } from '../config-types';

export const ActivityUrlConfig: Array<ConfigParams> = [
  {
    Page: '活动列表页',
    PCURL: '/activity',
    WapURL: '/mobile/market',
    WapURLParams: [
      {
        ParamsName: 'active',
        ParamsType: 'query',
        FixedValue: 'C010',
        MatchedUrlFn: (params) => {
          return params.active == 'C010';
        },
      },
    ],
  },
  {
    Page: '活动详情页',
    PCURL: '/activity/details',
    PCDynamicUrl: '/activity/[...all]',
    PCURLParams: [
      {
        ParamsName: 'id',
        ParamsType: 'query',
      },
      {
        ParamsName: 'platform',
        ParamsType: 'query',
        FixedValue: 'desktop',
      },
    ],
    WapURL: '/mobile/activity/details',
    WapURLParams: [
      {
        ParamsName: 'id',
        ParamsType: 'query',
      },
      {
        ParamsName: 'platform',
        ParamsType: 'query',
        FixedValue: 'mobile',
      },
    ],
  },
  {
    Page: 'AI品鉴会',
    PCURL: '/aijudge',
    PCDynamicUrl: '/aijudge/[...all]',
    PCURLParams: [
      {
        ParamsName: 'active',
        ParamsType: 'query',
      },
    ],
    WapURL: '/mobile/aijudge/home/',
    WapExtraUrl: ['/mobile/aijudge/'],
    WapURLParams: [
      {
        ParamsName: 'active',
        ParamsType: 'query',
      },
    ],
  },
  {
    Page: '新财年启动大会',
    PCURL: '/kickoff/fy2425',
    PCDynamicUrl: '/kickoff/fy2425/[...all]',
    PCURLParams: [
      {
        ParamsName: 'region',
        ParamsType: 'query',
      },
    ],
    WapURL: '/mobile/kickoff/fy2425/home/',
    WapExtraUrl: ['/mobile/kickoff/fy2425/'],
    WapURLParams: [
      {
        ParamsName: 'region',
        ParamsType: 'query',
      },
    ],
  },
  {
    Page: '联想创新科技大会',
    PCURL: '/activity/fy2526/techworld',
    PCDynamicUrl: '/activity/[...all]',
    PCExtraUrl: ['/activity/FY2526/techworld'],
    WapURL: '/mobile/activity/fy2526/techworld/',
    WapExtraUrl: ['/mobile/activity/FY2526/techworld/'],
  },
  {
    Page: '新财年启动大会',
    PCURL: '/activity/fy2627/kickoff',
    PCDynamicUrl: '/activity/[...all]',
    PCExtraUrl: ['/activity/fy2627/kickoff'],
    WapURL: '/mobile/activity/fy2627/kickoff/',
    WapExtraUrl: ['/mobile/activity/fy2627/kickoff/'],
  },
];
